/**
 * string2ArrayBuffer2 是一个JavaScript函数，用于将字符串转化为ArrayBuffer。
 * 这个函数通过获取字符串中每个字符的编码值，然后将其存储在Uint8Array中来实现这一点，
 * 最后返回一个包含这些值的ArrayBuffer。
 *
 * 函数的参数：
 * str - 需要转化为ArrayBuffer的字符串
 *
 * 函数的返回值：
 * 这个函数返回一个ArrayBuffer，其中包含了输入字符串中每个字符的编码值。
 *
 * 例外：
 * 如果给定字符串中的任何字符的编码值不在0到255之间，则函数会抛出一个错误。
 */
export function string2ArrayBuffer2(str) {
    const buffer = new ArrayBuffer(str.length);
    const arr = new Uint8Array(buffer);
    for (let i = 0; i < str.length; i++) {
        let charCode = str.charCodeAt(i);
        if (charCode < 0 || charCode > 255) { //
            throw new Error(`The character code ${charCode} at index ${i} is outside the range of a byte.`);
        }
        arr[i] = charCode;
    }
    return buffer;
}

/**
 * @param Date
 * @returns {date format yyyy-MM-dd}
 */
export function getDataYMD(date) {
    return date.getFullYear() + "-" + ('0' + (date.getMonth() + 1)).slice(-2) + "-" + ('0' + date.getDate()).slice(-2)
}

export function downloadSimpleExcelWithData(excelData, fileName) {
    const XLSX = require('xlsx');
    let mData = excelData

    let workbook = XLSX.utils.book_new();
    let sheet = XLSX.utils.aoa_to_sheet(mData);
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");

    const wbout = XLSX.write(workbook, {bookType: 'xlsx', type: 'binary'});
    const blob = new Blob([string2ArrayBuffer2(wbout)], {type: 'application/octet-stream'});

    let link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    link.click();

    URL.revokeObjectURL(link.href);
}

export function  downloadStaticExcelByPath(path, fileName) {
    let link = document.createElement('a');
    link.style.display = 'none';
    link.download = fileName;
    link.href = path;

    link.click();

    URL.revokeObjectURL(link.href);
}


export function createRandomPassword() {
    let lowerCase = 'abcdefghijklmnopqrstuvwxyz';
    let upperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let number = '0123456789';
    // 各选3个
    let lowerCaseStr = '';
    let upperCaseStr = '';
    let numberStr = '';
    for (let i = 0; i < 3; i++) {
        lowerCaseStr += lowerCase[Math.floor(Math.random() * lowerCase.length)];
        upperCaseStr += upperCase[Math.floor(Math.random() * upperCase.length)];
        numberStr += number[Math.floor(Math.random() * number.length)];
    }
    return upperCaseStr + lowerCaseStr + numberStr;

}
